
import { useEffect, useState } from 'react'
import { supabase } from '@/integrations/supabase/client'

export type AppRole = 'admin' | 'user'

export function useUserRole() {
  const [role, setRole] = useState<AppRole | null>(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const loadUserRole = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession()
        if (!session?.user) {
          setRole(null)
          return
        }

        const { data, error } = await supabase
          .from('user_roles')
          .select('role')
          .eq('user_id', session.user.id)
          .single()

        if (error) {
          console.error('Error loading user role:', error)
          setRole(null)
          return
        }

        setRole(data.role as AppRole)
      } catch (error) {
        console.error('Error in loadUserRole:', error)
        setRole(null)
      } finally {
        setIsLoading(false)
      }
    }

    loadUserRole()

    // Subscribe to auth state changes
    const { data: { subscription } } = supabase.auth.onAuthStateChange(() => {
      loadUserRole()
    })

    return () => {
      subscription.unsubscribe()
    }
  }, [])

  return { role, isLoading }
}
